/**
 ********************************************************************************************
 * 설정
 ********************************************************************************************
 */

let HOST_URL;
let SYS_HOST_URL;
let KIOSK_HOST_URL;

// 250904 SSL 관련으로 설정 변경 (http > https)
// 250908 scsadmin ssl 인증서 적용하여 http > https로 변경
if (process.env.NODE_ENV == 'production') {
    HOST_URL = 'https://api.studycafe.momu24.com'; // for production
    SYS_HOST_URL = 'https://scsadmin.momu24.com';
    KIOSK_HOST_URL = 'https://app.studycafe.momu24.com';
} else {
    HOST_URL = 'http://localhost:8888'; // for develment
    SYS_HOST_URL = 'http://localhost:9999';
    KIOSK_HOST_URL = 'http://localhost:11221';
}

export const HOST = HOST_URL;
export const SYS_HOST = SYS_HOST_URL;
export const KIOSK_HOST = KIOSK_HOST_URL;

// KAKAO MAP KEY
export const KAKAO_MAP_KEY = 'cd18fa8603d04ceff86d0e326d7caadd';
// export const KAKAO_MAP_KEY = 'e90bee7a1a2084eeff672e0e4c1e5482';
export const CRYPTO_KEY = 'tkfkdgksmssoEkfthdbfdlrjsrkdgofk';
export const CRYPTO_IV = 'dnflEkfdlQjwufk~';

/**
 ********************************************************************************************
 * store actions 이름 정의
 ********************************************************************************************
 */

// store-actions- ACT_SERVER_REQUEST
export const ACT_SERVER_REQUEST = 'ACT_SERVER_REQUEST';
// store-actions- ACT_SERVER_REQUEST_ASYNC
export const ACT_SERVER_REQUEST_ASYNC = 'ACT_SERVER_REQUEST_ASYNC';
// store-actions- ACT_SERVER_REQUEST_ALL
export const ACT_SERVER_REQUEST_ALL = 'ACT_SERVER_REQUEST_ALL';
// store-actions- ACT_GET_INIT_DATA
export const ACT_GET_INIT_DATA = 'ACT_GET_INIT_DATA';

/**
 ********************************************************************************************
 * 서버 요청 type 정의
 ********************************************************************************************
 */
///////////////////
// 0. 회원가입
///////////////////
export const REQ_USER_REGIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/user/registe/insert',
    method: 'post',
}
///////////////////
// 1. 로그인
///////////////////
export const REQ_USER_LOGIN = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/user/mobileLogin',
    method: 'post',
}

///////////////////
// 2. 자동 로그인
///////////////////
export const REQ_USER_TOKEN_LOGIN = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/user/mobileTokenLogin',
    method: 'post',
}

///////////////////
// 2. 리스트
///////////////////

// 신규 스터디카페 목록
export const REQ_NEW_STORE_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/store/newStore/get/list',
    method: 'get',
}

// 추천 스터디카페 목록
export const REQ_RECOMMEND_STORE_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/store/recommendStore/get/list',
    method: 'get',
}

// 내주변 스터디카페 목록
export const REQ_NEARBY_STORE_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/store/nearbyStore/get/list',
    method: 'get',
}
// 유저 가입된 카페 목록
export const REQ_USER_JOIN_STORE_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/user/joinStore/get/list',
    method: 'get',
}

// 검색한 매장 리스트 조회
export const REQ_SEARCH_STORE_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/store/search/get/list',
    method: 'get',
}

// 내매장 상세정보 리스트
export const REQ_MY_STORE_DETAIL_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/user/mystore/detail/get/list',
    method: 'post',
}
///////////////////
// 3. 회사정보
///////////////////
// 추천 스터디카페 목록
export const REQ_COMPANY_INFO = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/centerInfo/get',
    method: 'get',
}

///////////////////
// 4. 검색정보 조회
///////////////////
// export const REQ_COMPANY_INFO = {
//     action_name: ACT_SERVER_REQUEST,
//     url: '/mobile/centerInfo/get',
//     method: 'get',
// }
// 선택된 매장에 유저가 가입이 되어있는지 체크
export const REQ_CHECK_USER_JOIN_TO_STORE = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/store/check/user',
    method: 'get',
}

///////////////////
// 5. 스터디카페 상세 정보
///////////////////

// 스터디카페 상세 정보 조회
export const REQ_STORE_INFO = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/store/info/get',
    method: 'get',
}

// 좌석/그룹룸/사물함 타입별 정보 조회
export const REQ_STORE_GOODS_TYPE_INFO_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/store/goods/type/info/get/list',
    method: 'get',
}

// 매장 좌석/그룹룸/사물함 이미지 정보 조회
export const REQ_STORE_GOODS_TYPE_IMAGE_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/store/goods/type/img/get/list',
    method: 'get',
}

// 매장 좌석 가격표 정보 조회
export const REQ_STORE_SEAT_PRICE_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/store/seat/price/get/list',
    method: 'get',
}

// 매장 그룹룸 가격표 정보 조회
export const REQ_STORE_GROOM_PRICE_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/store/groom/price/get/list',
    method: 'get',
}

// 매장 사물함 가격표 정보 조회
export const REQ_STORE_LOCKER_PRICE_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/store/locker/price/get/list',
    method: 'get',
}


///////////////////
// 6. 지역 정보
///////////////////

// 시/도 조회
export const REQ_AREA_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/area/get/list',
    method: 'get',
}

// 구/시 조회
export const REQ_CITY_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/city/get/list',
    method: 'get',
}

// 동/구 조회
export const REQ_TOWN_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/town/get/list',
    method: 'get',
}

// 호선 조회
export const REQ_SUBWAYLINE_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/subwayline/get/list',
    method: 'get',
}

// 역 조회
export const REQ_STATION_LIST = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/station/get/list',
    method: 'get',
}
///////////////////
// 7. 매장등록
///////////////////
export const REQ_SET_MYSTORE = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/user/registe/mystore',
    method: 'post',
}
export const REQ_REGISTE_NEWSTORE = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/user/registe/newstore',
    method: 'post',
}
///////////////////
// 7. 인증
///////////////////
export const REQ_AUTH = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/user/auth/req',
    method: 'post',
}
export const REQ_RE_AUTH = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/user/auth/re_req',
    method: 'post',
}
export const REQ_CHECK_AUTH = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/user/auth/check',
    method: 'post',
}
export const REQ_CHECK_USER_ID = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/user/idChk',
    method: 'post',
}
///////////////////
// 8. 정보수정
///////////////////
export const REQ_PASS_EDIT = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/user/update/password',
    method: 'post',
}

export const REQ_INFO_EDIT = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/user/update/info',
    method: 'post',
}

// 회원 탈퇴
export const REQ_INFO_DELETE = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/user/delete',
    method: 'post',
}


// 매장 옵션
export const REQ_STORE_OPTION = {
    action_name: ACT_SERVER_REQUEST,
    url: '/mobile/store/getStoreOption',
    method: 'get',
}
 


// WEBPACK FOOTER //
// ./src/js/config.js